<template>
	<el-scrollbar wrapClass="scrollbar-wrapper">
		<div style="height: 35px"></div>
		<el-menu
			mode="vertical"
			:show-timeout="200"
			:default-openeds="opends"
			:default-active="activeNav"
			background-color="#fff"
			text-color="#000"
			active-text-color="#333">
			<sidebar-item :routes="routes"></sidebar-item>
		</el-menu>
	</el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
	components: { SidebarItem },
	data() {
		return {
			openedsNav: []
		}
	},
	computed: {
		...mapGetters([
			'routes',
			'sidebar'
		]),
		activeNav() {
			if (!!this.$route.meta.pointTo) {
				return this.$route.meta.pointTo
			} else if (this.$route.matched.length > 2) {
				return this.$route.matched[this.$route.matched.length - 2].path
			} else {
				return this.$route.path
			}
		}
	},
	props: {
		opends: {
			type: Array,
			default() {
				return []
			}
		}
	},
	methods: {
		checkRoutes(routes) {
			(routes || this.routes).forEach(item => {
				const name = item.name
				if (name && item.meta) {
					if (item.meta.cache) {
						this.$store.dispatch('addCacheViews', name)
					}
					// 动态收起展开
					// if (item.meta.open && !this.openedsNav.includes(name)) {
					// 	this.openedsNav.push(name)
					// }
				}
				const children = item.children
				if (!!children) {
					this.checkRoutes(children)
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>

</style>